var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("g",null,[React.createElement("g",{"key":0},React.createElement("path",{"fill":"#3b5998","d":"M46.5 93C72.181 93 93 72.181 93 46.5S72.181 0 46.5 0 0 20.819 0 46.5 20.819 93 46.5 93z"})),React.createElement("g",{"key":1},React.createElement("path",{"fill":"#fff","d":"M57.872 48.441h-8.305V79H36.984V48.441H31v-10.74h5.984v-6.949C36.984 25.782 39.335 18 49.68 18l9.321.04v10.424h-6.763c-1.109 0-2.669.556-2.669 2.927v6.32h9.404z"}))])));
}

Facebook.defaultProps = {"width":"93","height":"93","viewBox":"0 0 93 93"};

module.exports = Facebook;

Facebook.default = Facebook;
